<template>
  <v-container fluid grid-list-md>
    <v-card>
      <v-card-title>
        Customers Accounts
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-cloud-search-outline"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :mobile-breakpoint="NaN"
        :no-data-text="noData"
        :loading="isLoading"
        :headers="headers"
        :items="CustomersList"
        :search="search"
      >
        <!-- <template v-slot:item.blc="{ item }">
          
        </template> -->

        <template v-slot:[`item.more`]="{ item }">
          <v-card
            flat
            color="transparent"
            class="d-flex justify-center align-center"
          >
            <!-- Show Balance Div icon -->
            <div :key="'blc' + item._id">
              <v-btn
                small
                :id="item._id"
                color="success"
                :loading="clickedID === item._id ? true : false"
                icon
                class="text-capitalize primary-text"
                @click="ShowBalance(item)"
              >
                <v-icon small>mdi-cash-multiple</v-icon>
              </v-btn>
            </div>
            <!-- Show Client Report -->
            <div :key="'trn' + item._id">
              <Custtransaction :CustomerID="item" />
            </div>
            <!-- Client more option -->
            <div :key="'info' + item._id">
              <CustomerInof :CustomerID="item" />
            </div>
          </v-card>
        </template>
      </v-data-table>

      <!-- Balance Dialog -->
      <v-dialog
        v-model="dialog"
        max-width="500px"
        transition="dialog-transition"
      >
        <v-card v-if="Balance.length > 0">
          <v-card-title class="headline justify-center">{{
            Balance.Name
          }}</v-card-title>

          <v-card-text class="font-weight-black title text-center">
            <template v-for="(item, index) in Balance">
              <p
                v-if="item.Amount != 0"
                :key="index"
                :class="{ 'red--text': item.loan == 'yess' ? true : false }"
              >
                {{ item.AmountType }}: {{ item.Amount.toLocaleString() }}
                {{ item.AmountType | MoneySigns }}
              </p>
            </template>
          </v-card-text>
        </v-card>
        <v-card v-else>
          <v-card-title class="headline justify-center">{{
            Balance.Name
          }}</v-card-title>

          <v-card-text class="font-weight-black title text-center">
            Empty Balance
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-card-actions>
        <v-speed-dial bottom left absolute direction="right" v-model="fab">
          <template v-slot:activator>
            <newClient :loadFunction="LoadCustomerData"></newClient>
          </template>
        </v-speed-dial>
      </v-card-actions>
    </v-card>
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";
// import Custtransaction from "@/components/CustomerTran.vue";

export default {
  components: {
    newClient: () => import("@/components/Clients/newClient.vue"),
    CustomerInof: () => import("@/components/Clients/CustomInfo.vue"),
    Custtransaction: () => import("@/components/Clients/CleintTran.vue"),
  },
  // components: { Custtransaction },
  data() {
    return {
      noData: "No Customers is availble",
      fab: false,
      isLoading: true,
      dialog: false,
      dialog2: false,
      clickedID: "",
      Balance: [],
      search: "",
      headers: [],
    };
  },
  computed: {
    ...mapGetters(["CustomersList"]),
  },
  methods: {
    HeaderIntialize() {
      return [
        {
          text: "Full Name",
          align: "left",
          value: "FullName",
        },
        { text: "Phone", value: "Cusphone" },
        { text: "Account", value: "AccountNumber" },

        // { text: "ID Number", value: "IDNomber", sortable: false },
        // { text: "Balance", value: "blc", align: "center", sortable: false },
        {
          text: "More",
          value: "more",
          align: "center",
          sortable: false,
        },
      ];
    },
    ShowBalance(item) {
      this.clickedID = item._id;
      this.Balance = [];
      // console.log(ID);
      this.$store
        .dispatch("INSERT_ONLY", {
          url: "/customer/balance",
          data: {
            AccountNumber: item.AccountNumber,
          },
        })
        .then(result => {
          this.clickedID = "";
          // console.log(result);
          if (result.status === 200) {
            this.dialog = true;
            this.Balance = result.data;
            this.Balance.Name = item.FullName;
          }
        })
        .catch(() => {
          // console.log(error);
          this.clickedID = "";
        });
    },
    LoadCustomerData() {
      this.$store
        .dispatch("SelectAll", {
          url: "/customer",
          MutName: "Save_Customers",
        })
        .then(() => {
          // console.log(data);
          this.isLoading = false;
        })
        .catch(() => {
          // console.log(error);
          this.isLoading = false;
        });
    },
  },

  created() {
    this.headers = this.HeaderIntialize();

    this.LoadCustomerData();
  },
};
</script>
